export function setStorage(key, item) {
    if (typeof item !== 'object') {
        localStorage.setItem(key, item);
        return;
    }
    localStorage.setItem(key, JSON.stringify(item));
}
export function getStorage(key) {
    const item = localStorage.getItem(key);
    if (!item)
        return item;
    try {
        return JSON.parse(item);
    }
    catch (e) {
        return item;
    }
}
export function delStorage(key) {
    localStorage.removeItem(key);
}
